import activeProducts from "./index";

export const getHeaderLogo = () => activeProducts?.header?.logo;
export const getFooterLogo = () => activeProducts?.footer?.logo;

export const getHeaderLink = id => {
  const link = activeProducts?.header?.links?.find(x => x.id === id);
  return link;
};
export const showHeaderLink = id => getHeaderLink(id) && !getHeaderLink(id)?.disabled;

export const getFooter = () => activeProducts?.footer;
export const getHeader = () => activeProducts?.header;

export const isOfflineOfferPermited = product => activeProducts?.mainProducts?.find(x => x.id === product)?.offlineOffer;

export const getActiveInsurersFromConfig = product =>
  activeProducts?.mainProducts
    ?.find(x => x.id === product)
    ?.insurers?.filter(i => !i.disabled)
    ?.map(i => i.id);

export const getActiveProductsFromConfig = () => activeProducts?.mainProducts.filter(p => !p.disabled);

export const getCouriers = () => activeProducts?.tenantSettings?.couriers;

export const getActiveInsurersWithCSCPricesFromConfig = product =>
  activeProducts?.mainProducts
    ?.find(x => x.id === product)
    ?.insurers?.filter(i => !i.disabled && i.hasPrice)
    ?.map(i => i.id);

export const getDocumentsObj = (product, insurer, productObj = "mainProducts") =>
  activeProducts?.[productObj]
    ?.find(x => x.id === product)
    ?.insurers?.find(x => x.id === insurer)
    ?.documents?.reduce((obj, item) => ({ ...obj, [item.id]: item.url }), {});

export const getDocumentsByIds = (product, insurer, documentIds = [], productObj = "mainProducts", lang = "bg") => {
  const documentsObj = getDocumentsObj(product, insurer, productObj);

  const documents = activeProducts?.[productObj]?.find(x => x.id === product)?.insurers?.find(x => x.id === insurer)?.documents;

  if (!documents || !documentsObj) return [];

  const filteredDocuments = documentIds.length ? documents.filter(document => documentIds.includes(document.id)) : documents;

  return filteredDocuments
    .map(document => {
      const link = documentsObj[document.id];

      if (!link) return null;

      return {
        id: document.id,
        link,
        name: lang === "en" ? document.labelEn ?? document.label : document.label
      };
    })
    .filter(Boolean);
};

export const getInsurerEuDocumentUrlLinks = (product, productObj = "mainProducts", lang = "bg", addHelpDoc = false) => {
  const insurers = activeProducts?.[productObj]?.find(({ id }) => id === product)?.insurers ?? [];

  const euDocumentLinks =
    insurers
      ?.map(({ id, documents = [] }) => ({
        id,
        link: documents.find(({ id: documentId }) => documentId === "euDocumentUrl")?.url,
        name: documents.find(({ id: documentId }) => documentId === "euDocumentUrl")?.[lang === "bg" ? "label" : "labelEn"]
      }))
      .filter(({ link }) => Boolean(link)) ?? [];

  const helpDocument = addHelpDoc ? insurers.flatMap(({ documents = [] }) => documents).find(({ id }) => id === "helpUrl") : null;

  return [
    ...euDocumentLinks,
    ...(helpDocument
      ? [
          {
            name: helpDocument?.[lang === "bg" ? "label" : "labelEn"] || "Помощ при щета",
            link: helpDocument.url
          }
        ]
      : [])
  ];
};

export const hasPromoCode = (product, insurer, productObj = "mainProducts") =>
  activeProducts?.[productObj]?.find(x => x.id === product)?.insurers?.find(x => x.id === insurer)?.hasPromoCode;

export const hasMoreThanOnePaymentMethod = (product, insurer) =>
  activeProducts?.mainProducts?.find(x => x.id === product)?.insurers?.find(x => x.id === insurer)?.paymentModes?.length > 1;

export const getPaymentModes = (product, insurer) => {
  const paymentModes = activeProducts?.mainProducts?.find(x => x.id === product)?.insurers?.find(x => x.id === insurer)?.paymentModes;

  if (paymentModes) {
    return paymentModes;
  }
  return ["1"]; // 1 - с карта, 2 - наложен платеж, 3 - Iris
};

export const bgPhonePrefix = "+359";

export const isCustomCarPriceEnabled = activeProducts?.isCustomCarPriceEnabled;
export const isChatBotEnabled = activeProducts?.chatBotEnabled;
export const isForeignerEnabled = activeProducts?.isForeignerEnabled;
export const isUnregisteredVehicleEnabled = activeProducts?.isUnregisteredVehicleEnabled;
export const isUnregisteredVehicleCascoPlusGOEnabled = activeProducts?.isUnregisteredVehicleCascoPlusGOEnabled;
